import { IPropertyField } from '../../../entities/common';

export function getCultureEnumMembers(enableMultiLanguageText?: boolean) {
	const items: IPropertyField[] = [];

	if (enableMultiLanguageText) {
		items.push(
			{
				name: 'tr-TR',
				type: 'string'
			},
			{
				name: 'en-US',
				type: 'string'
			}
		);
	} else {
		items.push({
			name: 'system',
			type: 'string'
		});
	}

	return items;
}
